import React, { useEffect } from 'react';
import {Link} from 'react-router-dom' 
import './header.css'
import CallToAction from './CallToAction';
import avatar from '../../assets/img/avatar.png'
import HeaderSocials from './HeaderSocials';
import AOS from 'aos'
import 'aos/dist/aos.css';

const Header = () => {
  useEffect(() => {
    AOS.init({duration: 800})
  }, []);
  return (
    <header id='header'>
      <div className="container header-container">
        <h4 data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="100">Hi I'm</h4>
        <h1 data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="200">Mussagy Remane</h1>
        <h4 data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="300" className="text-light">
          Front End Developer
        </h4>
        <CallToAction />
        <div className="header-low" >
          <HeaderSocials/>
          <div className="avatar" data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="1100">
            <img src={avatar} alt="Mussagy Remane" />
          </div>
          <div className='scroll-down' data-aos="fade-down" data-aos-anchor-placement="top-bottom" data-aos-delay="1400">
            <Link to="/contact" className='scroll-down'>Scroll Down</Link>
          </div>
        </div>
      </div>
    </header>
    )
}

export default Header;
